import { ReactTFC } from "../../../../../../../utils/fp/missing-ts-parts";
import React, { useEffect, useRef, useState } from "react";
import { css } from "@emotion/react";
import { GooglePayData } from "../GooglePayData";
import Core from "@adyen/adyen-web/dist/types/core";
import GooglePayT from "@adyen/adyen-web/dist/types/components/GooglePay";
import { useExternalScript } from "../../../../../../../hooks/use-external-script";

const id = "googlepay-container";

export const GooglePay: ReactTFC<{
  adyenInstance: Core;
  environment: "test" | "live";
  googlePayOptions: {
    merchantId: string;
    gatewayMerchantId: string;
  };
  data: GooglePayData["data"] | null;
  state: GooglePayT | null;
  setState: React.Dispatch<React.SetStateAction<GooglePayT | null>>;
}> = props => {
  const [loaded, setLoaded] = useState(false);
  const ref = useRef<null | GooglePayT>(null);

  useExternalScript(
    {
      src: "https://pay.google.com/gp/p/js/pay.js",
      async: true,
    },
    () => {
      setLoaded(true);
    },
  );

  function mount() {
    const i = props.adyenInstance;

    const gPay = i.create("googlepay", {
      configuration: {
        gatewayMerchantId: props.googlePayOptions.gatewayMerchantId,
        merchantId: props.googlePayOptions.merchantId,
      },
    });

    return gPay.mount(`#${id}`);
  }

  useEffect(() => {
    if (loaded) {
      const gPay = mount();

      gPay.onComplete((data: GooglePayData["data"]) => {
        console.log("complete");
      });

      props.setState(gPay);
      ref.current = gPay;

      return () => {
        ref.current = null;
        props.setState(null);

        gPay.remove();
      };
    }
  }, [loaded]);

  return (
    <div
      id={id}
      css={css`
        display: none;
      `}
    />
  );
};
